export default "<app-budget-table [columns]=\"columns\" [hasFooter]=\"false\"></app-budget-table>\n\n"